<div class="mobile-header-toolbar">
    <div class="mobile-title-row">
        <button *ngIf="showReturnButton" mat-icon-button color="accent" type="button" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="mobile-title">{{ ueberschrift }}</h3>
    </div>
    <div class="mobile-header-toolbar__actions">
        <ng-content select="[mobileHeaderActions]"></ng-content>
    </div>
</div>
